import React from 'react';
import './AnalyticsSection.css';

const BRAND_GRAD = 'linear-gradient(90deg,#6366F1,#8B5CF6 55%,#D946EF)';

const INSIGHT_CARDS = [
  { icon: 'bx-trending-up',    title: 'Operational insights',    desc: 'Throughput, backlog, and rejection trends across every crew and location.' },
  { icon: 'bx-dollar-circle',  title: 'Financial insights',      desc: 'Cost per inspection and budget burn, tracked as the work happens.' },
  { icon: 'bx-shield-quarter', title: 'Compliance insights',     desc: 'Audit readiness and documentation completeness, always current.' },
  { icon: 'bx-pulse',          title: 'Project health insights', desc: 'Defect trends and rejection rates surfaced before they escalate.' },
];

function AnalyticsSection() {
  return (
    <section style={{ position: 'relative', background: '#15102A', padding: '120px 56px', overflow: 'hidden' }}>
      <div className="oc-analytics-bg">
        <img src={`${process.env.PUBLIC_URL}/assets/img/apps/oculo/dark-analytics.png`} alt="Analytics dashboards" />
      </div>
      <div style={{ position: 'relative', zIndex: 2, maxWidth: 1240, margin: '0 auto' }}>
        <div style={{ maxWidth: 560 }}>
          <span className="oc-reveal" style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>FROM PAPER TO INTELLIGENCE</span>
          <h2 className="oc-reveal" style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 42, lineHeight: 1.08, letterSpacing: '-0.02em', color: '#fff' }}>
            Turn analog records into{' '}
            <span style={{ background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>actionable analytics.</span>
          </h2>
          <p className="oc-reveal" style={{ margin: '22px 0 0', fontFamily: 'Montserrat,sans-serif', fontSize: 18, lineHeight: 1.65, color: 'rgba(255,255,255,0.72)' }}>
            The information once trapped on paper becomes live data the moment Oculo structures it. Every inspection feeds dashboards your teams can act on: fewer manual hours, lower cost per inspection, and faster decisions across the project.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 40 }} className="oc-grid-2">
            {INSIGHT_CARDS.map((card) => (
              <div key={card.title} className="oc-reveal oc-insight-card">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 11 }}>
                  <div style={{ flex: '0 0 auto', width: 42, height: 42, borderRadius: 11, background: 'rgba(99,102,241,0.10)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className={'bx ' + card.icon} style={{ fontSize: 23, background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }} />
                  </div>
                  <span style={{ font: '700 16px Montserrat,sans-serif', color: '#fff' }}>{card.title}</span>
                </div>
                <p style={{ margin: 0, fontFamily: 'Montserrat,sans-serif', fontSize: 14, lineHeight: 1.55, color: 'rgba(255,255,255,0.60)' }}>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AnalyticsSection;
